import * as React from 'react';

import CreateSale from '../containers/sales/CreateSale';
import BaseSaleHistoryLayout from "~/apps/pos/mobile/pages/BaseSaleHistoryLayout";


export default function({ saleId, step }) {
  return (
    BaseSaleHistoryLayout(
      <CreateSale saleId={saleId} step={step} />
    )
  );
};
